import "@babel/polyfill";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

// We include bootstrap *before* our router so that our styles can override bootstrap's
import "./assets/css/tsny_bootstrap.scss";
import BootstrapVue from "bootstrap-vue";

import router from "./router";
import store from "./store";

import VueMask from "v-mask";

Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});
